import type { BaseCellProps } from ".";
import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { HStack } from "@design-system/HStack/HStack";

interface Props extends BaseCellProps<boolean> {
    disabled: boolean;
}

export const BooleanCell = ({ value, finishEditing, disabled }: Props) => (
    <HStack justify="center">
        <div onClick={(event) => event.stopPropagation()}>
            <Checkbox
                checked={value === true}
                onCheckedChange={() => finishEditing(value !== true)}
                disabled={disabled}
            />
        </div>
    </HStack>
);
